import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";

import Textfield from "../../shared/textfield";
import AccessLocalStorage from "../../../services/localStorage";
import { button, title } from "../../../style2";
//import { getApiUrl } from "../../../services/api_service";

export default function ProblemsAndDiagnoses(props) {
  const maxProblemDiagnosis = 10;
  const [disabledField, setDisabledField] = useState(true);
  const [problemDiagnosisList, setProblemDiagnosisList] = useState([
    { problemDiagnosis: "" },
  ]);

  // const handleCancelEdit = () => {
  //   setDisabledField(true);
  // };

  // const handleEdit = () => {
  //   setDisabledField(!disabledField);
  //   if (!disabledField) {
  //     // To save changes here
  //   }
  // };

  const handleProblemDiagnosisDelete = (index) => {
    let list = [...problemDiagnosisList];
    //console.log("deleding index:", index);
    list.splice(index, 1);
    //console.log("new list", list);
    setProblemDiagnosisList(list);
  };

  const handleProblemDiagnosisAdd = () => {
    setProblemDiagnosisList([
      ...problemDiagnosisList,
      { problemDiagnosis: "" },
    ]);
  };

  const handleProblemDiagnosisChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...problemDiagnosisList];
    list[index][name] = value;
    setProblemDiagnosisList(list);
  };

  const profile = props.profile;

  return (
    <Box ml={2} mr={2} mb={2}>
      {profile.userDiagnosisList?.filter(t => !t.isOtherProblems).map((d, index) => (
        <div key={index}>
          <Grid container>
            <Grid item xs={12}>
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    p: 1,
                    m: 1,
                    bgcolor: "background.paper",
                    borderRadius: 1,
                    alignItems: "center",
                  }}
                >
                  <Typography>
                    Problem/Diagnosis {index !== 0 && index}
                  </Typography>
                  {index !== 0 && !disabledField && (
                    <IconButton
                      aria-label='delete'
                      onClick={() => handleProblemDiagnosisDelete(index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Textfield
                  name='problemDiagnosis'
                  id='problemDiagnosis'
                  disabled={disabledField}
                  value={d.title}
                  onChange={(e) => handleProblemDiagnosisChange(e, index)}
                  multiline
              rows={2}
                />
              </Grid>
            </Grid>
          </Grid>
          <Box m={2} />
          {problemDiagnosisList.length - 1 === index &&
            problemDiagnosisList.length < maxProblemDiagnosis &&
            !disabledField && (
              <>
                <Grid
                  item
                  sm={12}
                  container
                  alignItems='center'
                  justifyContent='flex-start'
                >
                  <Button
                    type='submit'
                    sx={button}
                    onClick={handleProblemDiagnosisAdd}
                  >
                    Add
                  </Button>
                </Grid>
                <Box m={2} />
              </>
            )}
        </div>
      ))}
      {profile.userDiagnosisList?.filter(t => t.isOtherProblems === true).length > 0 && profile.userDiagnosisList?.filter(t => t.isOtherProblems === true)[0].title !== "" ?
        <Grid container sm={12}>
          <Grid item xs={12}>
            <Textfield
              title={"Other Problems"}
              disabled={disabledField}
              value={profile.userDiagnosisList?.filter(t => t.isOtherProblems === true)[0].title}
              multiline
              rows={2}
            />
          </Grid>
        </Grid> : null}

      <Box m={4} />
      <Divider />
      <Box m={2} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography sx={title}>
            Other key information
          </Typography>
        </Grid>
        {profile.clinicalInformation?.backgroundHistory && profile.clinicalInformation?.backgroundHistory !== "" ? <Grid item xs={12}>
          <Textfield
            title='Background History'
            value={profile.clinicalInformation?.backgroundHistory}
            disabled={disabledField}
            multiline
              rows={2}
          />
        </Grid> : null}
        {profile.clinicalInformation?.activeProblems && profile.clinicalInformation?.activeProblems !== "" ? <Grid item xs={12}>
          <Textfield
            title='Active Problems'
            value={profile.clinicalInformation?.activeProblems}
            disabled={disabledField}
            multiline
              rows={2}
          />
        </Grid> : null}
        {profile.clinicalInformation?.currentManagement && profile.clinicalInformation?.currentManagement !== "" ? <Grid item xs={12}>
          <Textfield
            title='Current Managment'
            value={profile.clinicalInformation?.currentManagement}
            disabled={disabledField}
            multiline
              rows={2}
          />
        </Grid> : null}
        {profile.clinicalInformation?.treatmentGoals && profile.clinicalInformation?.treatmentGoals !== "" ? <Grid item xs={12}>
          <Textfield
            title='Treatment Goals'
            value={profile.clinicalInformation?.treatmentGoals}
            disabled={disabledField}
            multiline
              rows={2}
          />
        </Grid> : null}
        {profile.clinicalInformation?.orthoticsEquipment && profile.clinicalInformation?.orthoticsEquipment !== "" ? <Grid item xs={12}>
          <Textfield
            title='Orthotics/Equipment'
            value={profile.clinicalInformation?.orthoticsEquipment}
            disabled={disabledField}
            multiline
              rows={2}
          />
        </Grid> : null}
        {profile.clinicalInformation?.keyInterventions && profile.clinicalInformation?.keyInterventions !== "" ? <Grid item xs={12}>
          <Textfield
            title='Key Interventions'
            value={profile.clinicalInformation?.keyInterventions}
            disabled={disabledField}
            multiline
              rows={2}
          />
        </Grid> : null}
      </Grid>
    </Box>
  );
}
